/**
 * @param {Date} date OPTIONAL
 */
export function getWeekDays (date) {
  const list = []
  const start = getMondayDate(date)
  for (let index = 0; index <= 6; index++) {
    list.push(addDays(start, index))
    if (index >= 6) { return list }
  }
}
/**
 * @param {*} date
 * @param {*} days
 */
export function addDays (date, days) {
  var result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}
/**
 * @param {*} date
 * @param {*} days
 */
export function reduceDays (date, days) {
  var result = new Date(date)
  result.setDate(result.getDate() - days)
  return result
}
/**
 * @param {Date} date OPTIONAL
 */
export function getMondayDate (date) {
  const d = date ? new Date(date) : new Date(Date.now())
  return d.setDate(d.getDate() - (d.getDay() + 6) % 7)
}
/**
 * @param {Date} date OPTIONAL
 */
export function getSundayDate (date) {
  const d = date ? new Date(date) : new Date(Date.now())
  return d.setDate(d.getDate() - (d.getDay() + 6) % 7 + 6)
}
/**
 * @param {Date} date OPTIONAL
 */
export function getDay (date) {
  const d = date ? new Date(date) : new Date(Date.now())
  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  var day = days[d.getDay()]
  return day
}
/**
 * @param {Date} date OPTIONAL
 */
export function getMonth (date) {
  const d = date ? new Date(date) : new Date(Date.now())
  var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  var month = months[d.getMonth()]
  return month
}
/**
 * @param {Date} date OPTIONAL
 */
export function getYear (date) {
  const d = date ? new Date(date) : new Date(Date.now())
  return d.getYear()
}
